function getSliderSettings(id) {
	return {
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		infinite: false,
		autoHeight	: true,
		swipeToSlide: true,
		adaptiveHeight: true,
		touchMove: true,
		asNavFor: `[data-id=${id}] .product__media-sublist`,
		prevArrow:
			'<div class=\'slick-arrow  slick-prev\'> <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">' +
			'<g clip-path="url(#clip0_1453_9716)"> <path d="M6.03982 20.7098L15.75 10.9994L6.03982 1.28906" stroke="#202020" stroke-width="1.2707" stroke-linecap="round" stroke-linejoin="round"/></g>' +
			'<defs><clipPath id="clip0_1453_9716"><rect width="20.9996" height="21" fill="white" transform="matrix(-1 0 0 1 21 0.5)"/></clipPath></defs>' +
			"</svg></div>",

		nextArrow:
			'<div class=\'slick-arrow  slick-next\'> <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">' +
			'<g clip-path="url(#clip0_1453_9716)"> <path d="M6.03982 20.7098L15.75 10.9994L6.03982 1.28906" stroke="#202020" stroke-width="1.2707" stroke-linecap="round" stroke-linejoin="round"/></g>' +
			'<defs><clipPath id="clip0_1453_9716"><rect width="20.9996" height="21" fill="white" transform="matrix(-1 0 0 1 21 0.5)"/></clipPath></defs>' +
			"</svg></div>",
		responsive: [
			{
				breakpoint: 990,
				settings: {
					slidesToShow: 1,
					adaptiveHeight: true,
					swipeToSlide: true,
					touchMove: true,
				},
			},
		],
	};
}

function getSubSliderProductSettings(id) {
	return {
		slidesToShow: 7,
		slidesToScroll: 1,
		arrows: false,
		autoHeight	: true,
		asNavFor: `[data-id=${id}] .product__media-list`,
		focusOnSelect: true,
		vertical: true,
		verticalSwiping: true,
		autoplay: false,
		infinite: false,
		adaptiveHeight: true,
		touchMove: true,
		swipeToSlide: true,
		responsive: [
			{
				breakpoint: 990,
				settings: {
					slidesToShow: 5.5,
					vertical: false,
					swipeToSlide: true,
					touchMove: true,
					verticalSwiping: false,
				},
			},
		],
	};
}

function getSliderSettingsSwiper() {
	return {
		slidesPerView: 5.5,
		direction: "horizontal",
		spaceBetween: 10,
		initialSlide: 0,
		autoHeight	: true,
		loop:true,
		freeMode: true,
		breakpoints: {
			990: {
				slidesPerView: "auto",
				direction: "vertical",
			}
		}
	}
}

function getSubSliderProductSettingsSwiper(swiper) {
	return {
		spaceBetween: 10,
		initialSlide: 0,
		loop:true,
		autoHeight	: true,
		navigation: {
			nextEl: ".main-product-next",
			prevEl: ".main-product-prev",
		},
		thumbs: {
			swiper: swiper,
		}
	}
}

document.addEventListener("DOMContentLoaded", function () {
	let media = document.querySelectorAll('.product__media-list-wrapper');
	media.forEach(element => {
		if (element.querySelector('.mySwiper')) {
			var swiper = new Swiper(element.querySelector('.mySwiper'), getSliderSettingsSwiper());
			var swiper2 = new Swiper(element.querySelector(".mySwiper2"), getSubSliderProductSettingsSwiper(swiper));
		}
	});
});

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	);
}

function inViewport(element) {
  // Get the elements position relative to the viewport

	var bb = element.getBoundingClientRect();

  // Check if the element is outside the viewport
  // Then invert the returned value because you want to know the opposite

	return !(bb.top > innerHeight || bb.bottom <= -10);
}

function productMobileSticky() {
  	var element = document.querySelector(".main-product .quantity-button-wrapper"); // Replace 'yourElementId' with the ID of your element
	let btn = document.querySelector(".qut-buy-wrapper-js");
	if(element){
		element.style['min-height'] = element.clientHeight + 'px'
	}
	if (inViewport(element)) {
		if (btn) {
			btn.classList.remove("fixed");
		}
	} else {
		if (btn) {
			btn.classList.add("fixed");
		}
	}
}

document.addEventListener("DOMContentLoaded", function () {
	if (document.querySelector(".main-product .quantity-button-wrapper") && window.innerWidth <= 767) {
		// productMobileSticky();
		window.addEventListener("scroll", () => {
			productMobileSticky();
		});
	}
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open"),
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	if(elementToFocus) {
		elementToFocus.focus();
	}
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*",
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this)),
		);

		var eventList = ["paste", "input"];

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/;

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ""
				) {
					e.currentTarget.value;
				} else {
					e.currentTarget.value = 1;
				}
			});
		}

		this.input.addEventListener("focusout", function (e) {
			if (e.currentTarget.value === "") {
				e.currentTarget.value = 1;
			}
		});
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options,
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid,
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this),
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`,
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this)),
		);
		this.querySelectorAll("button").forEach((button) => {
			if (this.querySelector(".header__localization-button") === button) return;
			if (this.querySelector(".header__localization-lang-button") === button)
				return;
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
		this.querySelectorAll('.close_icon').forEach(btn => {
			btn.addEventListener('click',(e)=>{
				e.preventDefault();
				this.querySelector('.mobile-facets__close--no-js').click();
			})
		})
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const parentMenuElement = detailsElement.closest('.has-submenu');
		const isOpen = detailsElement.hasAttribute("open");
		const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

		function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement);

				if (window.matchMedia('(max-width: 990px)')) {
					document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
				}
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button"),
			);

			setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
		  	
		if (summaryElement.classList.contains('menu-drawer__menu-item')) {
			this.querySelectorAll('summary.menu-drawer__menu-item').forEach(item => {
				if (summaryElement != item) {
					item.parentNode.removeAttribute('open');
					item.parentNode.classList.remove('menu-opening');
				}
			})
		}
      }, 100);
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
				window.removeEventListener('resize', this.onResize);
			});
			this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
				submenu.classList.remove('submenu-open');
			});
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
				document.body.classList.remove("overflow-hidden", "megamenu-drawer-open");
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"));
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
		detailsElement.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary"),
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.querySelector(".shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom",
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset,
			)}px`,
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		window.addEventListener('resize', this.onResize);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add("overflow-hidden", "megamenu-drawer-open");
	}
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this),
		);
		this.addEventListener("click", (event) => {
			if (event.target.nodeName === "MODAL-DIALOG") this.hide();
		});
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
	}

	show(opener) {
		this.openedBy = opener;
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		this.querySelector(".template-popup")?.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
	}

	hide() {
		document.body.classList.remove("overflow-hidden");
		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");
		button?.addEventListener("click", () => {
			document.querySelector(this.getAttribute("data-modal"))?.show(button);
		});
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			"click",
			this.loadContent.bind(this),
		);
		if (this.getAttribute("data-autoplay")) {
			this.loadContent();
		}
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(
					true,
				),
			);

			this.setAttribute("loaded", true);
			window.pauseAllMedia();
			/*this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			).focus();*/

			const videoObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (this.getAttribute("data-autoplay")) {
							let playPromise = entry.target.play();
							if (playPromise !== undefined) {
								playPromise.then((_) => {}).catch((error) => {});
							}
							//entry.target.play()
						}
					} else {
						entry.target.pause();
					}
				});
			});

			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			);

			if (
				deferredElement.nodeName == "VIDEO" ||
				deferredElement.nodeName == "IFRAME"
			) {
				// force autoplay for safari

				if (this.classList.contains("video-section__media")) {
					let playPromise = deferredElement.play();
					if (playPromise !== undefined) {
						playPromise.then((_) => {}).catch((error) => {});
					}

					videoObserver.observe(deferredElement);
				} else {
					deferredElement.play();
				}
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector(".slider");
		this.sliderItems = this.querySelectorAll(".slider__slide");
		this.pageCount = this.querySelector(".slider-counter--current");
		this.pageTotal = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener("scroll", this.update.bind(this));
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
	}

	initPages() {
		if (!this.sliderItems.length === 0) return;
		this.slidesPerPage = Math.floor(
			this.slider.clientWidth / this.sliderItems[0].clientWidth,
		);
		this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
		this.update();
	}

	update() {
		if (!this.pageCount || !this.pageTotal) return;
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

		if (this.currentPage === 1) {
			this.prevButton.setAttribute("disabled", true);
		} else {
			this.prevButton.removeAttribute("disabled");
		}

		if (this.currentPage === this.totalPages) {
			this.nextButton.setAttribute("disabled", true);
		} else {
			this.nextButton.removeAttribute("disabled");
		}

		this.pageCount.textContent = this.currentPage;
		this.pageTotal.textContent = this.totalPages;
	}

	onButtonClick(event) {
		event.preventDefault();
		const slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + this.sliderItems[0].clientWidth
				: this.slider.scrollLeft - this.sliderItems[0].clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slider-component", SliderComponent);

function formatMoney (t, e = window.theme.moneyFormat) {
	/* Shopify Money Format */
	function o(t, e) {
	return void 0 === t ? e : t
	}
	function i(t, e, i, r) {
	if (e = o(e, 2),
		i = o(i, ","),
		r = o(r, "."),
		isNaN(t) || null == t)
		return 0;
	t = (t / 100).toFixed(e);
	var n = t.split(".");
	return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? r + n[1] : "")
	}
	"string" == typeof t && (t = t.replace(".", ""));
	var r = ""
	, n = /\{\{\s*(\w+)\s*\}\}/
	, a = e || this.money_format;
	switch (a.match(n)[1]) {
	case "amount":
		r = i(t, 2);
		break;
	case "amount_no_decimals":
		r = i(t, 0);
		break;
	case "amount_with_comma_separator":
		r = i(t, 2, ".", ",");
		break;
	case "amount_with_space_separator":
		r = i(t, 2, " ", ",");
		break;
	case "amount_with_period_and_space_separator":
		r = i(t, 2, " ", ".");
		break;
	case "amount_no_decimals_with_comma_separator":
		r = i(t, 0, ".", ",");
		break;
	case "amount_no_decimals_with_space_separator":
		r = i(t, 0, " ");
		break;
	case "amount_with_apostrophe_separator":
		r = i(t, 2, "'", ".")
	}
	return a.replace(n, r)
};
class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.updateVariantStatuses();
		
		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			this.updateVariantInfo();
			// this.updateMedia();
			// this.updateMediaSub();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.priceUpdate($(this).closest('.product'));
		}
		// To filter slide base on selected color option
		this.updateSlide($(this).closest('.product'));
	}

	priceUpdate(parent) {
		if (parent[0].querySelector('.price.price--product.price--on-sale')) {
			parent[0].querySelector('.price.price--product .price-item--regular') ? parent[0].querySelector('.price.price--product .price-item--regular').innerHTML = formatMoney(this.currentVariant.compare_at_price) : null;
			parent[0].querySelector('.price.price--product .price-item--sale') ? parent[0].querySelector('.price.price--product .price-item--sale').innerHTML = formatMoney(this.currentVariant.price) : null;

			let parentPrice = parent[0].querySelector('.price.price--product');

			let priceCompare = parentPrice.querySelectorAll('.price__compare');
			let discountItems = parentPrice.querySelectorAll('.discount-item');
			if(priceCompare.length > 0) {
				priceCompare.forEach(element => {
					if(this.currentVariant.compare_at_price > this.currentVariant.price) {
						element.innerHTML = `<s class="price-item price-item--regular">${formatMoney(this.currentVariant.compare_at_price)}</span>`;
						element.classList.remove('d-none');
					} else {
						element.innerHTML = `<span class="price-item price-item--sale">${formatMoney(this.currentVariant.price)}</span>`;
						element.classList.add('d-none');
					}
				});
			}
			if(discountItems.length > 0) {
				discountItems.forEach(element => {
					if(this.currentVariant.compare_at_price > this.currentVariant.price) {
						// element.innerHTML = formatMoney(this.currentVariant.compare_at_price);
						let discountPercentage = Math.round((this.currentVariant.compare_at_price - this.currentVariant.price) / this.currentVariant.compare_at_price * 100);
						element.innerHTML = discountPercentage + '% Off';
						element.classList.remove('d-none');
					} else {
						// element.innerHTML = formatMoney(this.currentVariant.price);
						element.classList.add('d-none');
					}
				});
			}
		} else {
			parent[0].querySelector('.price.price--product .price-item--regular') ? parent[0].querySelector('.price.price--product .price-item--regular').innerHTML = formatMoney(this.currentVariant.price) : null;
			parent[0].querySelector('.price.price--product .price-item--sale') ? parent[0].querySelector('.price.price--product .price-item--sale').innerHTML = formatMoney(this.currentVariant.compare_at_price) : null;
		}
	}

	updateVariantInfo() {
		let info = this.querySelectorAll('.select-variant-info');
		if (info.length === 0) {
			return;
		}
		info.forEach(ele => {
			ele.classList.add('d-none');
		});
		this.currentVariant.options.forEach(element => {
			this.querySelector(`.select-variant-info[data-name="${element}"]`) ? this.querySelector(`.select-variant-info[data-name="${element}"]`).classList.remove("d-none") : null;
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value,
		).concat(
			fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll("input")).find(
					(radio) => radio.checked,
				).value;
			}),
		);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				this.options.sort();
				variant.options.sort();

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
		}
	}

	// Filer slide
	updateSlide(parent) {
		let filterValue = this.colorOptionSelected;

if (this.patternOptionSelected) {
    filterValue =
      this.colorOptionSelected + "|" + this.patternOptionSelected;
}
		// "this.colorOptionSelected" is selected color option
		if (!this.colorOptionSelected) return;
		// Main slider image filter using slick
		let dummyData = $('.media-data-js', parent);
		if (!dummyData.length === 0) return;
		let mainSlider = $('.product__media-list-dummy', dummyData);
		let thumbSlider = $('.product__media-sublist-dummy', dummyData);
		let id = parent[0].dataset.id;

		// if ($(`[data-media-alt="${this.dataset.section}-${this.colorOptionSelected}"]`, mainSlider).length > 0) {
		// }
		// let height = $('.product__media-list', parent).height();
		// $('.product__media-list', parent).slick("unslick");
		// $('.product__media-list', parent).css('height', height);
		$('.product__media-list .swiper-wrapper', parent).empty();
		let selectedSlides = $(`[data-media-alt="${this.dataset.imageSection}-${filterValue}"]`, mainSlider).clone();
		if (selectedSlides.length === 0) {
			selectedSlides = $(`[data-section-id="${this.dataset.imageSection}-slide"]`, mainSlider).clone();
		}
		$('.product__media-list .swiper-wrapper', parent).html(selectedSlides);
		
		// $('.product__media-list', parent).css('height', '');
		// $('.product__media-list', parent).slick(getSliderSettings(id));

		// if ($(`[data-sub-media-alt="${this.dataset.section}-${this.colorOptionSelected}"]`, thumbSlider).length > 0) {
		// }
		// let heightSub = $('.product__media-sublist', parent).height();
		// $(".product__media-sublist", parent).slick("unslick");
		// $('.product__media-sublist', parent).css('height', heightSub);
		$(".product__media-sublist .swiper-wrapper", parent).empty();
		let selectedSlidesThumb = $(`[data-sub-media-alt="${this.dataset.imageSection}-${filterValue}"]`, thumbSlider).clone();
		if (selectedSlidesThumb.length === 0) {
			selectedSlidesThumb = $(`[data-sub-section-id="${this.dataset.imageSection}-slide"]`, thumbSlider).clone();
		}
		$(".product__media-sublist .swiper-wrapper", parent).html(selectedSlidesThumb);
		// $('.product__media-sublist', parent).css('height', '');
		// $('.product__media-sublist', parent).slick(getSubSliderProductSettings(id));

		var swiper = new Swiper(parent[0].querySelector('.mySwiper'), getSliderSettingsSwiper());
		var swiper2 = new Swiper(parent[0].querySelector(".mySwiper2"), getSubSliderProductSettingsSwiper(swiper));

		const opener = parent[0].querySelectorAll("modal-opener");
		opener.forEach(element => {
			const button = element.querySelector("button");
			button?.addEventListener("click", () => {
				document.querySelector(element.getAttribute("data-modal"))?.show(button);
			});
		});

		// $(`[data-section-id="${this.dataset.section}-slide"]`, parent).closest(".slick-slide").removeClass('selected-shade');
		// $('.product__media-list', parent).slick('slickUnfilter');

		// if ($(`[data-media-alt="${this.dataset.section}-${this.colorOptionSelected}"]`, parent).length > 0) {
		// 	$(`[data-media-alt="${this.dataset.section}-${this.colorOptionSelected}"]`, parent).closest(".slick-slide").addClass('selected-shade');
		// 	$('.product__media-list', parent).slick('slickFilter','.selected-shade');
		// }
		
		// Sub slider image filter using slick
		// $(`[data-sub-section-id="${this.dataset.section}-slide"]`, parent).closest(".slick-slide").removeClass('selected-shade');
		// $('.product__media-sublist', parent).slick('slickUnfilter');

		// if ($(`[data-sub-media-alt="${this.dataset.section}-${this.colorOptionSelected}"]`, parent).length > 0) {
		// 	$(`[data-sub-media-alt="${this.dataset.section}-${this.colorOptionSelected}"]`, parent).closest(".slick-slide").addClass('selected-shade');
		// 	$('.product__media-sublist', parent).slick('slickFilter','.selected-shade');
		// }
	}

	updateMedia() {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

		const newMedia = document.querySelector(
			`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
		);

		$(".product__media-list").slick("unslick");

		if (!newMedia) return;

		const parent = newMedia.parentElement;

		parent.prepend(newMedia);

		window.setTimeout(() => {
			parent.scroll(0, 0);
		});

		$(".product__media-list").slick(getSliderSettings());
		$('.product__media-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
			window.pauseAllMedia();
		});
	}

	updateMediaSub() {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

		const newMediaSub = document.querySelector(
			`[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
		);

		$(".product__media-sublist").slick("unslick");

		if (!newMediaSub) return;

		const parentSub = newMediaSub.parentElement;

		parentSub.prepend(newMediaSub);

		window.setTimeout(() => {
			parentSub.scroll(0, 0);
		});

		$(".product__media-sublist").slick(getSubSliderProductSettings());
	}

	updateURL() {
		if (!this.classList.contains("variant-selects--quick-view")) {
			if (this.closest('.part-of-collection-product')) return;
			if (!this.currentVariant) return;
			window.history.replaceState(
				{},
				"",
				`${this.dataset.url}?variant=${this.currentVariant.id}`,
			);
		}
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment`,
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(":checked").value === variant.option1,
		);
		const inputWrappers = [...this.querySelectorAll(".product-form__input")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			];
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(":checked") ? inputWrappers[index - 1].querySelector(":checked").value : null;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected,
				)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				if (input.tagName === "OPTION") {
					input.innerText = input.getAttribute("value");
				} else if (input.tagName === "INPUT") {
					input.classList.remove("disabled");
				}
			} else {
				if (input.tagName === "OPTION") {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							"[value]",
							input.getAttribute("value"),
						);
				} else if (input.tagName === "INPUT") {
					input.classList.add("disabled");
				}
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant?.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	renderProductInfo() {
		// Store the variant that's being used for this fetch to avoid race conditions
		const variantForFetch = this.currentVariant;
		if (!variantForFetch) return;
		
		let url = `${this.dataset.url}?variant=${variantForFetch.id}&section_id=${this.dataset.section}`;
		let partOfCollection = $(this).closest('.part-of-collection-product');
		let productWrapper = null;
		if (partOfCollection) {
			url = `${this.dataset.url}?variant=${variantForFetch.id}`
			productWrapper = $(this).closest('.main-product');
		}
		fetch(url,)
			.then((response) => response.text())
			.then((responseText) => {
				// Check if the variant has changed since the fetch was initiated
				// Only update if the current variant matches the one we fetched
				if (this.currentVariant && this.currentVariant.id !== variantForFetch.id) {
					return; // Variant changed, ignore this response
				}
				
				const id = `price-${this.dataset.section}`;
				const html = new DOMParser().parseFromString(responseText, "text/html");
				if (partOfCollection) {
					let productWrapperHtml = html.querySelector('.main-product');
					if(productWrapperHtml) {
						const destination = productWrapper[0].querySelector(".price-wrapper-js");
						const source = productWrapperHtml.querySelector('.price-wrapper-js');
						if (source && destination) destination.innerHTML = source.innerHTML;
					}
				} else {
					const destination = document.getElementById(id);
					const source = html.getElementById(id);
	
					if (source && destination) destination.innerHTML = source.innerHTML;
	
					document
						.getElementById(`price-${this.dataset.section}`)
						?.classList.remove("visibility-hidden");
					const inventorySource = html.getElementById(
						`Inventory-${
							this.dataset.originalSection
								? this.dataset.originalSection
								: this.dataset.section
						}`,
					);
					const inventoryDestination = document.getElementById(
						`Inventory-${this.dataset.section}`,
					);
	
					if (source && destination) destination.innerHTML = source.innerHTML;
					if (inventorySource && inventoryDestination)
						inventoryDestination.innerHTML = inventorySource.innerHTML;
	
					const price = document.getElementById(`price-${this.dataset.section}`);
	
					if (price) price.classList.remove("visibility-hidden");
	
					if (inventoryDestination)
						inventoryDestination.classList.toggle(
							"visibility-hidden",
							inventorySource.innerText === "",
						);
				}
				// Use the stored variant instead of this.currentVariant
				this.toggleAddButton(
					!variantForFetch.available,
					window.variantStrings.soldOut,
				);
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const addButton = document
			.getElementById(`product-form-${this.dataset.section}`)
			?.querySelector('[name="add"]');

		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", true);
			if (text) addButton.textContent = text;
		} else {
			addButton.removeAttribute("disabled");
			addButton.textContent = window.variantStrings.addToCart;
		}

		// Also update buy now button if it exists
		const buyNowButton = document
			.getElementById(`product-form-${this.dataset.section}`)
			?.querySelector('.product-checkout-btn');
		
		if (buyNowButton) {
			if (disable) {
				buyNowButton.setAttribute("disabled", true);
				if (text) buyNowButton.textContent = text;
			} else {
				buyNowButton.removeAttribute("disabled");
				buyNowButton.textContent = 'Buy it now';
			}
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const addButton = document
			.getElementById(`product-form-${this.dataset.section}`)
			?.querySelector('[name="add"]');
		if (!addButton) return;
		addButton.textContent = window.variantStrings.unavailable;
		
		// Also update buy now button if it exists
		const buyNowButton = document
			.getElementById(`product-form-${this.dataset.section}`)
			?.querySelector('.product-checkout-btn');
		if (buyNowButton) {
			buyNowButton.setAttribute("disabled", true);
			buyNowButton.textContent = window.variantStrings.unavailable;
		}
		
		document
			.getElementById(`price-${this.dataset.section}`)
			?.classList.add("visibility-hidden");
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`,
		);
		if (inventory) inventory.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
				input.classList.remove("hidden");
				document.querySelector(`[for="${input.id}"]`) && document.querySelector(`[for="${input.id}"]`).classList.remove('hidden')
			} else {
				input.classList.add("disabled");
				input.classList.add("hidden");
				document.querySelector(`[for="${input.id}"]`) && document.querySelector(`[for="${input.id}"]`).classList.add('hidden')
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		fieldsets.forEach(element => {
			let value = Array.from(element.querySelectorAll("input")).find((radio) => radio.checked);
			value = value ? value.value : null;
			element.querySelector('.selected-option-value') && value ? element.querySelector('.selected-option-value').innerHTML = `: ${value}` : null;
			if (element.closest('.product-form__colors-wrapper')) {
				this.colorOptionSelected = value;
			}
			if (element.querySelector('span')?.innerText.trim() == 'Pattern') {
    this.patternOptionSelected = value;
}
		});
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked,
			) ? Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked,
			).value : null;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

(function () {
	const header = () => {
		const submenuDetails = document.querySelectorAll(
			".header__submenu li details",
		);

		submenuDetails.forEach((targetDetail) => {
			targetDetail.addEventListener("click", () => {
				submenuDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute("open");
					}
				});
			});
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const recommendations = html.querySelector("product-recommendations");

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					if (
						!this.querySelector("slideshow-component") &&
						this.classList.contains("complementary-products")
					) {
						this.remove();
					}

					if (html.querySelector(".grid__item")) {
						this.classList.add("product-recommendations--loaded");
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 400px 0px",
		}).observe(this);
	}
}

customElements.define("product-recommendations", ProductRecommendations);

window.onload = function () {
	const coolimageScript = document.querySelectorAll(
		'script[src*="cool-image-magnifier"]',
	);
	let coolimageGallery = document.querySelector(".product__media-wrapper");

	if (coolimageScript.length > 0 && coolimageGallery) {
		coolimageGallery.classList.add("cool-image-custom");
	}
};


class CollectionPage {
	constructor(parent) {
		this.parent = parent;
		if (!this.parent) {
			return;
		}
		this.init();
	}
	collectionPageData = () => {
		let collectionData = this.parent.querySelector('.collection-page-data .content-data-wrapper');
		let readMoreLessBtns = collectionData?.querySelectorAll('.read-more-less');

		readMoreLessBtns.forEach(ele => {
			ele.addEventListener('click', (e) => {
				let wrapper = e.currentTarget.closest('.content-data-wrapper');
				let contentData = wrapper.querySelector('.content-data');
				contentData.classList.toggle('content-data-ellipsis');

				if (contentData.classList.contains('content-data-ellipsis')) {
					e.currentTarget.innerHTML = "Read more";
				} else {
					e.currentTarget.innerHTML = "Read less";
				}
			})
		});
	}
	init = () => {
		this.collectionPageData();
	}
}
new CollectionPage(document.querySelector('.template-collection'));

class ProductTabs {
	constructor(parent) {
		this.parent = parent;
		if (this.parent.length === 0) {
			return;
		}
		this.init();
	}
	tabChange = () => {
		let parents = this.parent;
		parents.forEach(parent => {
			let tabNav = parent.querySelectorAll('.tab-nav-item');
			if (tabNav.length === 0) {
				return;
			}
			tabNav.forEach(ele => {
				ele.addEventListener('click', (e) => {
					let that = e.currentTarget;
					if (that.classList.contains('dimensions-popup')) {
						document.querySelector('.size-guide-js') ? document.querySelector('.size-guide-js').click() : null;
						return;
					}
					tabNav.forEach(tab => {
						tab.classList.remove("active");
					});
					that.classList.add('active');
					let data = that.querySelector('.tab-nav-link').dataset.tabTarget
					let contents = parent.querySelectorAll('.tabs-content');
					contents.forEach(content => {
						content.classList.remove('active');
					});
					parent.querySelector(`.tabs-content[data-tab-target=${data}]`) ? parent.querySelector(`.tabs-content[data-tab-target=${data}]`).classList.add('active') : null;
				})
			});
		});
	}
	accordionToggle = () => {
		let parents = this.parent;
		parents.forEach(parent => {
			let accordionItems = parent.querySelectorAll('.accordion-item');
			if (accordionItems.length === 0) {
				return;
			}
			accordionItems.forEach(item => {
				let header = item.querySelector('.accordion-header');
				if (!header) {
					return;
				}
				header.addEventListener('click', (e) => {
					e.preventDefault();
					let that = item;
					if (that.classList.contains('dimensions-popup')) {
						document.querySelector('.size-guide-js') ? document.querySelector('.size-guide-js').click() : null;
						return;
					}
					let isActive = that.classList.contains('active');
					let content = that.querySelector('.accordion-content');
					let icon = that.querySelector('.accordion-icon svg');
					
					if (isActive) {
						that.classList.remove('active');
						content.classList.remove('open');
						header.setAttribute('aria-expanded', 'false');
						if (icon) {
							icon.classList.remove('icon-up');
							icon.classList.add('icon-down');
						}
					} else {
						that.classList.add('active');
						content.classList.add('open');
						header.setAttribute('aria-expanded', 'true');
						if (icon) {
							icon.classList.remove('icon-down');
							icon.classList.add('icon-up');
						}
					}
				});
			});
		});
	}
	init = () => {
		this.tabChange();
		this.accordionToggle();
	}
}
new ProductTabs(document.querySelectorAll('.product-tabs-wrapper'));

class FrequentlyBought {
	constructor(parent) {
		this.parent = parent;
		if (!this.parent) {
			return;
		}
		this.init();
	}
	updateBtn = () => {
		let parent = this.parent;
		let addToCartBtn = parent.querySelector('.add-to-cart-btn-frequently-bought');
		let products = parent.querySelectorAll('.freq-product-item.active');
		if (products.length === 0) {
			addToCartBtn.classList.remove('disabled')
			addToCartBtn.setAttribute('disabled', '');
		} else {
			addToCartBtn.classList.remove('disabled')
			addToCartBtn.removeAttribute('disabled');
		}
	}
	clickEvent = () => {
		let parent = this.parent;
		let checkbox = parent.querySelectorAll('.custom-control-input');
		checkbox.forEach(ele => {
			ele.addEventListener('change', (e) => {
				let that = e.currentTarget;
				let wrapper = that.closest('.freq-product-item');
				that.checked ? wrapper.classList.add('active') : wrapper.classList.remove('active');
				this.priceUpdate();
				this.updateBtn();
			})
		});
		let addToCartBtn = parent.querySelector('.add-to-cart-btn-frequently-bought');
		addToCartBtn && addToCartBtn.addEventListener('click', (e) => {
			let that = e.currentTarget;
			if (that.classList.contains('disabled')) {
				return;
			}
			let formData = {
				items: []
			};
			let products = parent.querySelectorAll('.freq-product-item.active');
			if (products.length === 0) {
				return;
			}
			products.forEach(element => {
				let id = element.dataset.id;
				id = parseInt(id);
				formData.items.push({id:id,quantity:1});
			});
			fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(formData)
			})
			.then(response => {
				return response.json();
			})
			.then(response => {
				console.log("response", response);
			})
			.catch((error) => {
				console.error('Error:', error);
			});
		})
	}
	variantChangeEvent = () => {
		let parent = this.parent;
		let products = parent.querySelectorAll('.freq-product-item');
		products.forEach(product => {
			let selectBoxes = product.querySelectorAll('select');
			selectBoxes.forEach(select => {
				select.addEventListener('change', (e) => {
					let that = e.currentTarget;
					let wrapper = that.closest('.freq-product-item');
					this.onChange(wrapper);
					this.priceUpdate();
				})
			});
		});
	}
	onChange = (wrapper) => {
		let prodJson = JSON.parse(wrapper.querySelector('.prod-json-js').innerText);
		let options = []
		wrapper.querySelectorAll('.option-wrapper select').forEach(select => {
			options.push(select.value);
		});
		let variant = prodJson.variants.find((variant) => {
			return !variant.options.map((option, index) => {
				return options[index] === option;
			}).includes(false);
		});
		if (!variant) {
			return;
		}
		wrapper.setAttribute('data-price', variant.price);
		wrapper.setAttribute('data-compare-price', variant.compare_at_price);
		wrapper.setAttribute('data-id', variant.id);
		let itemPriceEl = wrapper.querySelector('.fbt-item-price');
		if (itemPriceEl) {
			itemPriceEl.innerHTML = this.formatMoney(variant.price);
		}
		let info = wrapper.querySelectorAll('.select-variant-info');
		if (info.length > 0) {
			info.forEach(ele => {
				ele.classList.add('d-none');
			});
			variant.options.forEach(element => {
				wrapper.querySelector(`.select-variant-info[data-name="${element}"]`) ? wrapper.querySelector(`.select-variant-info[data-name="${element}"]`).classList.remove("d-none") : null;
			});
		}
	}
	priceUpdate = () => {
		let parent = this.parent;
		let products = parent.querySelectorAll('.freq-product-item.active');
		let price = 0;
		let comparePrice = 0;
		products.forEach(element => {
			let priceAttr = element.getAttribute('data-price');
			price += parseInt(priceAttr ? priceAttr : '0') ;
			let compareAttr = element.getAttribute('data-compare-price');
			comparePrice += parseInt(compareAttr ? compareAttr : '0');
		});
		let saleEl = parent.querySelector('.price.total-amount .price-item--sale');
		let regularEl = parent.querySelector('.price.total-amount .price-item--regular');
		if (saleEl) saleEl.innerHTML = this.formatMoney(price);
		if (regularEl) {
			regularEl.innerHTML = this.formatMoney(comparePrice);
			if (comparePrice > 0) {
				regularEl.closest('.price__compare') && regularEl.closest('.price__compare').classList.remove('d-none');
			} else {
				regularEl.closest('.price__compare') && regularEl.closest('.price__compare').classList.add('d-none');
			}
		}
	}
	formatMoney = function (t, e = window.theme.moneyFormat) {
		/* Shopify Money Format */
		function o(t, e) {
		return void 0 === t ? e : t
		}
		function i(t, e, i, r) {
		if (e = o(e, 2),
			i = o(i, ","),
			r = o(r, "."),
			isNaN(t) || null == t)
			return 0;
		t = (t / 100).toFixed(e);
		var n = t.split(".");
		return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? r + n[1] : "")
		}
		"string" == typeof t && (t = t.replace(".", ""));
		var r = ""
		, n = /\{\{\s*(\w+)\s*\}\}/
		, a = e || this.money_format;
		switch (a.match(n)[1]) {
		case "amount":
			r = i(t, 2);
			break;
		case "amount_no_decimals":
			r = i(t, 0);
			break;
		case "amount_with_comma_separator":
			r = i(t, 2, ".", ",");
			break;
		case "amount_with_space_separator":
			r = i(t, 2, " ", ",");
			break;
		case "amount_with_period_and_space_separator":
			r = i(t, 2, " ", ".");
			break;
		case "amount_no_decimals_with_comma_separator":
			r = i(t, 0, ".", ",");
			break;
		case "amount_no_decimals_with_space_separator":
			r = i(t, 0, " ");
			break;
		case "amount_with_apostrophe_separator":
			r = i(t, 2, "'", ".")
		}
		return a.replace(n, r)
	};
	init = () => {
		this.clickEvent();
		this.variantChangeEvent();
	}
}
new FrequentlyBought(document.querySelector(".frequently-bought"))

class ProductStyle {
	constructor(parent) {
		this.parent = parent;
		if (this.parent.length === 0) {
			return;
		}
		this.init();
	}
	clickEvent = () => {
		let parents = this.parent;
		parents.forEach(parent => {
			let styleButton = parent.querySelectorAll('.style-wrapper');
			styleButton.forEach(ele => {
				ele.addEventListener('click', (e) => {
					let that = e.currentTarget.querySelector('.style-button');
					let handle = that.dataset.handle;
					let mainProduct = that.closest('.main-product');
					let data = mainProduct.querySelector('.style-product-data-wrapper-js');
					let prodWrapper = data.querySelector(`.product-dummy-data-wrapper[data-handle="${handle}"]`);
					this.renderHtmlData(mainProduct, prodWrapper);
					let wrapper = that.closest('.product-style-inner');
					let buttons = wrapper.querySelectorAll('.style-wrapper');
					buttons.forEach(button => {
						button.classList.remove('active');
					});
					that.closest('.style-wrapper').classList.add('active');
					that.closest('.product-style-wrapper').querySelector('.selected-style-value').innerHTML = ": " + that.dataset.value;
				})
			});
		});


		
	}
	renderHtmlData = (productWrapper, responseHTML) => {
		let modalId = productWrapper.querySelector('.product-media-modal').id;
		productWrapper.querySelector('.product-parameters') ? productWrapper.querySelector('.product-parameters').innerHTML = responseHTML.querySelector('.product-parameters')?.innerHTML : null;
		productWrapper.querySelector('.product-media-modal') ? productWrapper.querySelector('.product-media-modal').innerHTML = responseHTML.querySelector('.product-media-modal')?.innerHTML : null;
		productWrapper.querySelector('.product-sizeguide-modal') ? productWrapper.querySelector('.product-sizeguide-modal').innerHTML = responseHTML.querySelector('.product-sizeguide-modal')?.innerHTML : null;
		productWrapper.querySelector('.quantity-button-wrapper') ? productWrapper.querySelector('.quantity-button-wrapper').innerHTML = responseHTML.querySelector('.quantity-button-wrapper')?.innerHTML : null;
		productWrapper.querySelector('.product-tabs-wrapper') ? productWrapper.querySelector('.product-tabs-wrapper').innerHTML = responseHTML.querySelector('.product-tabs-wrapper')?.innerHTML : null;
		productWrapper.querySelector('.product-tabs-wrapper') ? new ProductTabs(productWrapper.querySelectorAll('.product-tabs-wrapper')) : null;
		productWrapper.querySelector('.product__title__wrapper') ? productWrapper.querySelector('.product__title__wrapper').innerHTML = responseHTML.querySelector('.product__title__wrapper')?.innerHTML : null;
		productWrapper.querySelector('.price-wrapper') ? productWrapper.querySelector('.price-wrapper').innerHTML = responseHTML.querySelector('.price-wrapper')?.innerHTML : null;
		let height = productWrapper.querySelector('.product__media-wrapper').offsetHeight;
		productWrapper.querySelector('.product__media-wrapper').style.height = `${height}px`;
		productWrapper.querySelector('.product__media-wrapper') ? productWrapper.querySelector('.product__media-wrapper').innerHTML = responseHTML.querySelector('.product__media-wrapper').innerHTML : null;
		productWrapper.querySelectorAll('modal-opener').forEach((ele) => {
			ele.setAttribute('data-modal', `#${modalId}`);
		})
		let id = productWrapper.dataset.id;
		let listMedia = productWrapper.querySelector('.product__media-list-style-dummy');
		listMedia.classList.remove('product__media-list-style-dummy');
		listMedia.classList.add('product__media-list');
		let subListMedia = productWrapper.querySelector('.product__media-sublist-style-dummy');
		subListMedia.classList.remove('product__media-sublist-style-dummy');
		subListMedia.classList.add('product__media-sublist');
		productWrapper.querySelector('.product__media-wrapper').style.height = ``;
		var swiper = new Swiper(productWrapper.querySelector('.mySwiper'), getSliderSettingsSwiper());
		var swiper2 = new Swiper(productWrapper.querySelector(".mySwiper2"), getSubSliderProductSettingsSwiper(swiper));

		// $('.product__media-list', productWrapper).slick(getSliderSettings(id));
		// $('.product__media-sublist', productWrapper).slick(getSubSliderProductSettings(id));
		// $('.product__media-list', productWrapper).on('afterChange', function(event, slick, currentSlide, nextSlide){
		// 	window.pauseAllMedia();
		// });
		
		const opener = productWrapper.querySelectorAll("modal-opener")
		opener.forEach(element => {
			const button = element.querySelector("button");
			button?.addEventListener("click", () => {
				document.querySelector(element.getAttribute("data-modal"))?.show(button);
			});
		});
		let modalDialog = productWrapper.querySelector('[id^="ModalClose-"]');
		modalDialog.addEventListener("click", () => {
			document.body.classList.remove("overflow-hidden");
			modalDialog.closest('.product-media-modal').removeAttribute("open");
			window.pauseAllMedia();
		});
	}
	init = () => {
		this.clickEvent();
	}
}
new ProductStyle(document.querySelectorAll('.product-style-wrapper'));

class ProductStyleSet {
	constructor(parent) {
		this.parent = parent;
		if (!this.parent) {
			return;
		}
		this.init();
	}
	clickEvent = () => {
			let styleButtons = document.querySelectorAll('.style-set-swatch-box');
			styleButtons.forEach(ele => {
				ele.addEventListener('click', (e) => {
					let that = ele;
					let handle = that.dataset.handle;
					let mainProduct = that.closest('.main-product');
					let data = mainProduct.querySelector('.style-product-data-wrapper-js');
					let prodWrapper = data.querySelector(`.product-dummy-data-wrapper[data-handle="${handle}"]`);
					this.renderHtmlData(mainProduct, prodWrapper);
					// let wrapper = that.closest('.product-style-inner');
					let buttons = document.querySelectorAll('.style-set-swatch-box');
					buttons.forEach(button => {
						button.classList.remove('active-product');
					});
					ele.classList.add('active-product');
					// that.closest('.product-style-wrapper').querySelector('.selected-style-value').innerHTML = ": " + that.dataset.value;
				})
			});

		
	}
	renderHtmlData = (productWrapper, responseHTML) => {
		let modalId = productWrapper.querySelector('.product-media-modal').id;
		productWrapper.querySelector('.product-parameters') ? productWrapper.querySelector('.product-parameters').innerHTML = responseHTML.querySelector('.product-parameters')?.innerHTML : null;
		productWrapper.querySelector('.product-media-modal') ? productWrapper.querySelector('.product-media-modal').innerHTML = responseHTML.querySelector('.product-media-modal')?.innerHTML : null;
		productWrapper.querySelector('.product-sizeguide-modal') ? productWrapper.querySelector('.product-sizeguide-modal').innerHTML = responseHTML.querySelector('.product-sizeguide-modal')?.innerHTML : null;
		productWrapper.querySelector('.quantity-button-wrapper') ? productWrapper.querySelector('.quantity-button-wrapper').innerHTML = responseHTML.querySelector('.quantity-button-wrapper')?.innerHTML : null;
		productWrapper.querySelector('.product-tabs-wrapper') ? productWrapper.querySelector('.product-tabs-wrapper').innerHTML = responseHTML.querySelector('.product-tabs-wrapper')?.innerHTML : null;
		productWrapper.querySelector('.product-tabs-wrapper') ? new ProductTabs(productWrapper.querySelectorAll('.product-tabs-wrapper')) : null;
		productWrapper.querySelector('.product__title__wrapper') ? productWrapper.querySelector('.product__title__wrapper').innerHTML = responseHTML.querySelector('.product__title__wrapper')?.innerHTML : null;
		productWrapper.querySelector('.price-wrapper') ? productWrapper.querySelector('.price-wrapper').innerHTML = responseHTML.querySelector('.price-wrapper')?.innerHTML : null;
		let height = productWrapper.querySelector('.product__media-wrapper').offsetHeight;
		productWrapper.querySelector('.product__media-wrapper').style.height = `${height}px`;
		productWrapper.querySelector('.product__media-wrapper') ? productWrapper.querySelector('.product__media-wrapper').innerHTML = responseHTML.querySelector('.product__media-wrapper')?.innerHTML : null;
		productWrapper.querySelectorAll('modal-opener').forEach((ele) => {
			ele.setAttribute('data-modal', `#${modalId}`);
		})
		let id = productWrapper.dataset.id;
		let listMedia = productWrapper.querySelector('.product__media-list-style-dummy');
		listMedia.classList.remove('product__media-list-style-dummy');
		listMedia.classList.add('product__media-list');
		let subListMedia = productWrapper.querySelector('.product__media-sublist-style-dummy');
		subListMedia.classList.remove('product__media-sublist-style-dummy');
		subListMedia.classList.add('product__media-sublist');
		productWrapper.querySelector('.product__media-wrapper').style.height = ``;
		var swiper = new Swiper(productWrapper.querySelector('.mySwiper'), getSliderSettingsSwiper());
		var swiper2 = new Swiper(productWrapper.querySelector(".mySwiper2"), getSubSliderProductSettingsSwiper(swiper));

		// $('.product__media-list', productWrapper).slick(getSliderSettings(id));
		// $('.product__media-sublist', productWrapper).slick(getSubSliderProductSettings(id));
		// $('.product__media-list', productWrapper).on('afterChange', function(event, slick, currentSlide, nextSlide){
		// 	window.pauseAllMedia();
		// });
		
		const opener = productWrapper.querySelectorAll("modal-opener")
		opener.forEach(element => {
			const button = element.querySelector("button");
			button?.addEventListener("click", () => {
				document.querySelector(element.getAttribute("data-modal"))?.show(button);
			});
		});
		let modalDialog = productWrapper.querySelector('[id^="ModalClose-"]');
		modalDialog.addEventListener("click", () => {
			document.body.classList.remove("overflow-hidden");
			modalDialog.closest('.product-media-modal').removeAttribute("open");
			window.pauseAllMedia();
		});
	}
	init = () => {
		this.clickEvent();
	}
}
new ProductStyleSet(document.querySelector('.product-style-set-main-wrapper'));